exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-select .dropdown{list-style:none;max-width:350px}.client-select .dropdown a.dropdown-toggle:after{margin-top:.5em;margin-left:10px}.client-select .dropdown .dropdown-menu{width:100%;max-height:35vh;overflow:auto}", ""]);

// exports
